import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import { Col, Divider, Dropdown, Row, Tooltip } from "antd";
import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { AiOutlineUserAdd } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getBeneficiaryDetails } from "../../apis/actions/recipient.actions";
import {
  getSponsorDetails,
  getUnsponsoredOrphans,
} from "../../apis/actions/sponsor.actions";
import { AppDispatch, RootState } from "../../apis/store";
import profile from "../../assets/icons/profileIcon.svg";
import { scroll } from "../../components/utils/utils";
import NavBar from "../../domains/communs/NavBar";
import BeneficiaryProfile from "../../domains/profile/beneficiary/BeneficiaryProfile";
import Services from "../../domains/profile/beneficiary/Services";
import ServicesRequests from "../../domains/profile/beneficiary/ServicesRequests";
import MenuProfile from "../../domains/profile/menu/MenuProfile";
import DonationPayment from "../../domains/profile/sponsor/DonationPayment";
import SponsorDisbursements from "../../domains/profile/sponsor/SponsorDisbursements";
import OldSystemPayments from "../../domains/profile/sponsor/OldSystemPayments";
import SponsorReports from "../../domains/profile/sponsor/SponsorReports";
import Loader from "../Loader/Loader";
import {
  beneficiaryMenu,
  getMenu,
  hasParticipantRole,
  schoolMenu,
  sponsorMenu,
  withOldSystemPayments,
  withParticipantMenu,
} from "../../data/MenuData";
import OrphansSponsorshipOverview from "../../domains/profile/sponsor/orphans/unsponsoredOrphans/OrphansSponsorshipOverview";
import OrphansUnSponsorshipOverview from "../../domains/profile/sponsor/orphans/unsponsoredOrphans/OrphansUnsponsorshipOverview";

import { SponsorProfile } from "../../domains/profile/sponsor/profile/SponsorProfile";
import OurSponsorOrphans from "../../domains/profile/sponsor/orphans/OurSponsorOrphans";
import AllSponsorOrphans from "../../domains/profile/sponsor/orphans/AllSponsorOrphans";
import SponsorRequestsOverview from "../../domains/profile/sponsor/requests/SponsorRequestsOverview";
import ServicesListRequestOverview from "../../domains/profile/beneficiary/services-list-request/ServicesListRequestOverview";
import ProgramListRequestsOverview from "../../domains/profile/beneficiary/program-list-request/ProgramListRequestsOverview";
import BankAccountList from "../../domains/profile/beneficiary/bank-accounts-list/BankAccountList";
import BeneficiaryPrograms from "../../domains/profile/beneficiary/programs/BeneficiaryPrograms";
import { MySponsorships } from "../../domains/profile/sponsor/sponsorship/MySponsorships";
import ProofPage from "../../domains/profile/beneficiary/proof-documents/ProofDocumentsPage";
import { EditSponsorProfile } from "../../domains/profile/sponsor/edit-profile/EditSponsorProfile";
import SponsorBooking from "../../domains/profile/sponsor/booking/SponsorBooking";
import OrphansActivitiesOverview from "../../domains/profile/sponsor/orphans/orphans-activities/OrphansActivitiesOverview";
import MonitoringRequest from "../../domains/profile/beneficiary/monitoring/Monitoring";
import RegistrationApplicationsUniversityRequest from "../../domains/profile/beneficiary/registration-universities/ResgitrationUniversityAppliationsRequests";
import RegistrationRequest from "../../domains/profile/beneficiary/registration-scholarship/Registration";
import Survey from "../../domains/profile/survey/Survey";
import CancelSponserShipOverview from "../../domains/profile/sponsor/cancelSponsorship/CancelSponserShipOverview";
import DroppedOutRequestsOverview from "../../domains/profile/beneficiary/dropped-out-requests/DroppedOutRequestsOverview";
import { getClub } from "../../apis/actions/scholarship.actions";
import AddWalletAmount from "../../domains/profile/sponsor/orphans/unsponsoredOrphans/AddWalletAmount";
import EndowmentOverview from "../../domains/profile/sponsor/endowment/EndowmentOverview";
import { setEditMode, setOtpId } from "../../apis/slices/recipientSlice";
import {
  getTargeted,
  isRoleEndower,
  isRoleSponsor,
} from "../../domains/profile/sponsor/orphans/utils";
import { getParticipantDetails } from "../../apis/actions/participants.actions";
import ShareOverview from "../../domains/profile/share/ShareOverview";
import ParticipantPhotos from "../../domains/profile/photos/ParticipantPhotos";
import ParticipantVideos from "../../domains/profile/videos/ParticipantVideos";
import DonationAmountOverview from "../../domains/profile/beneficiary/donation/donation-amount/DonationAmountOverview";
import DonationProductOverview from "../../domains/profile/beneficiary/donation/donation-product/DonationProductOverview";
import ContactUsOverview from "../../domains/profile/beneficiary/contact-us/ContactUsOverview";
import { getSchoolProfileDetails } from "../../apis/actions/school.actions";
import StudentsPage from "../../domains/profile/school/students/StudentsPage";
import NotesPage from "../../domains/profile/school/notes/NotesPage";
import { SchoolProfile } from "../../domains/profile/school/SchoolProfile";

interface LayoutHeaderProps extends React.HTMLProps<HTMLDivElement> {}
const LayoutProfile = ({ children, ...props }: LayoutHeaderProps) => {
  const [active, setActive] = useState(
    () => Number(localStorage.getItem("activeState")) || 1
  );
  const currentRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem("activeState", active.toString());
  }, [active]);
  const [isExpanded, setIsExpanded] = useState(true);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };
  const [cookies] = useCookies(["role"]);

  const role = cookies?.role;
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(true);
  const [isWalletModalVisible, setIsWalletModalVisible] = useState(false);
  const location = useLocation();
  const selectedKey = location?.state?.selectedKey;
  const editMode = useSelector(
    (state: RootState) => state?.recipient?.editMode
  );
  const OtpId = useSelector((state: RootState) => state?.recipient?.OtpId);
  useEffect(() => {
    const fetchData = async () => {
      if (role === "beneficiary") {
        await dispatch(getBeneficiaryDetails());
        await dispatch(getClub());
      } else if (isRoleSponsor(role)) {
        await dispatch(getSponsorDetails({ sponsor_id: OtpId }));
        await dispatch(
          getUnsponsoredOrphans({
            limit: 8,
            page: 1,
            beneficiary_type: "",
            sponsorship_type: "",
          })
        );
      } else if (isRoleEndower(role)) {
        await dispatch(getParticipantDetails());
      } else if (role === "school") {
        await dispatch(getSchoolProfileDetails());
      }

      setLoading(false);
    };
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, selectedKey, OtpId]);
  const beneficiary = useSelector(
    (state: RootState) => state?.recipient?.beneficiaryDetails
  );
  const sponsor = useSelector(
    (state: RootState) => state?.sponsor?.sponsorDetails
  );
  const hasRelatedAccounts = sponsor?.related_accounts?.length > 0;
  const switchAccountItems = sponsor?.related_accounts?.map((account: any) => ({
    key: String(account.id),
    label: account.name,
  }));

  const handleSwitchAccount = ({ key }: { key: string }) => {
    const selectedAccount = sponsor?.related_accounts?.find(
      (account: any) => String(account.id) === key
    );

    dispatch(setOtpId(selectedAccount?.id ?? key));
    navigate("/profile", { state: { selectedKey: "s3" } });
  };

  const { unsponsoredOrphans } = useSelector(
    (state: RootState) => state?.sponsor
  );
  const participantDetails = useSelector(
    (state: RootState) => state?.participants?.participantDetails
  );
  const { data: schoolProfileDetails } = useSelector(
    (state: RootState) => state?.school?.schoolProfileDetails
  );
  const { club } = useSelector((state: RootState) => state?.scholarship);
  const [content, setContent] = useState<any>(
    role === "beneficiary" ? (
      <BeneficiaryProfile data={beneficiary} role={role} />
    ) : isRoleSponsor(role) ? (
      <SponsorProfile data={sponsor} role={role} />
    ) : role === "school" ? (
      <SchoolProfile />
    ) : (
      <SponsorProfile data={participantDetails} role={role} />
    )
  );
  const getDefaultSelectedKey = () =>
    role === "beneficiary" ? "b1" : isRoleSponsor(role) ? "s3" : "s1";
  const [selectedItemMenu, setSelectedItemMenu] = useState(
    selectedKey ? selectedKey : getDefaultSelectedKey()
  );
  useEffect(() => {
    setSelectedItemMenu(selectedKey ? selectedKey : getDefaultSelectedKey());
    setLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedKey]);
  useEffect(() => {
    if (selectedKey !== "b1") {
      dispatch(setEditMode(false));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItemMenu, editMode]);
  const handleSwitch = (selectedItemMenu: any) => {
    if (role === "beneficiary") {
      switch (selectedItemMenu) {
        case "b1":
          return <BeneficiaryProfile data={beneficiary} role={role} />;
        case "b2":
          return (
            <div>
              <ProofPage />
            </div>
          );
        case "b3":
          return <BankAccountList />;
        case "b4":
          return <div>الطلبات الشخصية</div>;
        case "b5":
          return <ServicesRequests />;
        case "b6":
          return <Services />;
        case "b7":
          return <ContactUsOverview />;
        case "b8":
          return <Survey targeted={getTargeted(role)} />;
        case "b10":
          return <ServicesListRequestOverview />;
        case "b11":
          return <BeneficiaryPrograms />;
        case "b13":
          return <RegistrationRequest />;
        case "b16":
          return <DroppedOutRequestsOverview />;
        case "b12":
          return <ProgramListRequestsOverview />;
        case "b14":
          return <MonitoringRequest />;
        case "b15":
          return <RegistrationApplicationsUniversityRequest />;
        case "b18":
          return <DonationAmountOverview />;
        case "b19":
          return <DonationProductOverview />;
        default:
          return <BeneficiaryProfile data={beneficiary} role={role} />;
      }
    } else if (isRoleSponsor(role)) {
      switch (selectedItemMenu) {
        case "s1":
          return <SponsorProfile data={sponsor} role={role} />;
        case "s18":
          return (
            <OrphansUnSponsorshipOverview
              type="unsponsored"
              orphans={unsponsoredOrphans}
            />
          );
        case "s2":
          return <MySponsorships data={sponsor} />;
        case "s3":
          // keyed by account so switching account resets the renew list
          return (
            <OrphansSponsorshipOverview
              key={OtpId}
              type="sponsored"
              orphans={[]}
            />
          );
        case "s17":
          return <CancelSponserShipOverview />;
        case "s4":
          return <EditSponsorProfile data={sponsor} />;
        case "s5":
          return (
            <OurSponsorOrphans
              // data={sponsor?.my_orphans_widows_needs}
              mobile={sponsor.mobile}
            />
          );
        case "s6":
          return (
            <AllSponsorOrphans
              data={sponsor.all_orphans_widows_needs}
              mobile={sponsor.mobile}
            />
          );
        case "s16":
          return <OrphansActivitiesOverview />;
        case "s7":
          return (
            <DonationPayment
              type={"donation"}
              isParticipant={hasParticipantRole(role)}
            />
          );
        case "s14":
          return <DonationPayment type={"payment"} />;
        case "s20":
          return <SponsorDisbursements />;
        case "s24":
          return <OldSystemPayments />;
        case "s15":
          return <SponsorBooking />;
        case "s8":
          return <SponsorRequestsOverview />;
        case "s9":
          return <SponsorReports />;
        case "s10":
          return <Survey targeted={getTargeted(role)} />;
        case "s19":
          return <EndowmentOverview />;
        case "s23":
          return <ShareOverview />;
        case "s21":
          return <ParticipantPhotos />;
        case "s22":
          return <ParticipantVideos />;
        default:
          return <SponsorProfile data={sponsor} role={role} />;
      }
    } else if (role === "school") {
      switch (selectedItemMenu) {
        case "s1":
          return <SchoolProfile />;
        case "sm":
          return <StudentsPage />;
        case "sm1":
          return <NotesPage />;

        default:
          return <SchoolProfile />;
      }
    } else {
      switch (selectedItemMenu) {
        case "s1":
          return <SponsorProfile data={participantDetails} role={role} />;
        case "s9":
          return <SponsorReports />;
        case "s7":
          return (
            <DonationPayment
              type={"donation"}
              isParticipant={hasParticipantRole(role)}
            />
          );
        case "s4":
          return <EditSponsorProfile data={participantDetails} />;
        case "s10":
          return <Survey targeted={getTargeted(role)} />;
        case "s19":
          return <EndowmentOverview />;
        case "s23":
          return <ShareOverview />;
        case "s21":
          return <ParticipantPhotos />;
        case "s22":
          return <ParticipantVideos />;
        default:
          return <SponsorProfile data={participantDetails} role={role} />;
      }
    }
  };

  useEffect(() => {
    const excludedKeys = ["nb", "nb1", "nb2", "ns1", "ns2", "nb4", "nb3"];
    if (excludedKeys.includes(selectedItemMenu)) {
      return;
    }
    setContent(handleSwitch(selectedItemMenu));
    scroll(currentRef);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItemMenu, sponsor, beneficiary, OtpId]);
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div
          className={`takaful--layout-container ${props?.className ?? ""}`}
          style={{ backgroundColor: "transparent" }}
        >
          <NavBar variant="homePage" />
          <div className="takaful--layout-profile-content">
            <div className="takaful--layout-icons-container takaful--icons-setting">
              {/* REQUESTED BY CLIENT / TO BE RETURNED IN THE FUTURE
              {[
                "sponsor",
                "sponsor_participant",
                "sponsor_endower",
                "sponsor_endower_participant",
              ].includes(role) ? (
                <Tooltip
                  overlayClassName="takaful--share-tooltip"
                  placement="right"
                  title="إضافة مبلغ في المحفظة"
                >
                  <div
                    className="takaful--navbar-profile-icon takaful--layout-profile-icon"
                    onClick={() => setIsWalletModalVisible(true)}
                  >
                    <img src={wallet} alt="setting" />
                  </div>
                </Tooltip>
              ) : (
                <div className="takaful--navbar-profile-icon  takaful--layout-profile-icon">
                  <SettingOutlined />
                </div>
              )}
                */}
              {role.includes("sponsor") && hasRelatedAccounts && (
                <Dropdown
                  menu={{
                    items: switchAccountItems,
                    onClick: handleSwitchAccount,
                  }}
                  placement="bottomRight"
                  trigger={["click"]}
                  overlayClassName="takaful--service-select-dropdown takaful--switch-account-dropdown"
                >
                  <Tooltip
                    overlayClassName="takaful--share-tooltip"
                    placement="right"
                    title="إنتقل إلى حساب آخر"
                  >
                    <div className="takaful--navbar-profile-icon  takaful--layout-profile-icon">
                      <AiOutlineUserAdd />
                      <span className="notification-badge">
                        {sponsor?.accounts_number}
                      </span>
                    </div>
                  </Tooltip>
                </Dropdown>
              )}
            </div>
            <div className="takaful--layout-profile-content-container">
              <div {...props} className="takaful--layout-header">
                <div className="takaful--layout-header-buttons">
                  <div
                    className="takaful--layout-header-button takaful--layout-header-back1"
                    onClick={() => setActive(1)}
                  />
                  <div
                    className="takaful--layout-header-button takaful--layout-header-back2"
                    onClick={() => setActive(2)}
                  />
                  <div
                    className="takaful--layout-header-button takaful--layout-header-back3"
                    onClick={() => setActive(3)}
                  />
                </div>

                <Row
                  className={`takaful--layout-header-title-image takaful--layout-header-back-img${active}`}
                >
                  <Col
                    xxl={16}
                    xl={16}
                    lg={16}
                    md={16}
                    sm={11}
                    xs={11}
                    className={`takaful--layout-header-first-title takaful--text-color-${
                      active === 1 ? "blue" : "white"
                    }`}
                  >
                    <span>مرحباً</span>
                    <div
                      className={`takaful--layout-header-name takaful--text-color-${
                        active === 1 ? "blue" : "white"
                      }`}
                    >
                      <img alt="" src={profile} />
                      <p>
                        {isRoleSponsor(role)
                          ? sponsor?.name
                          : isRoleEndower(role)
                            ? participantDetails?.name
                            : role === "school"
                              ? schoolProfileDetails.name
                              : beneficiary?.name}
                      </p>
                    </div>
                  </Col>
                  {isRoleSponsor(role) ? (
                    <Col xxl={8} xl={8} lg={8} md={8} sm={10} xs={11}>
                      <div
                        className={`takaful--layout-header-second-box  takaful--text-color-${
                          active === 1 ? "blue" : "white"
                        }`}
                      >
                        <div className="takaful--layout-header-second-box-content takaful--layout-header-second-box-wallet">
                          <p>{sponsor?.surplus_amount}</p>
                          <span>مبلغ في المحفظة</span>
                        </div>
                        <Divider
                          type="vertical"
                          className={`takaful--layout-header-divider takaful--background-color-${
                            active === 1 ? "blue" : "white"
                          }`}
                        />
                        <div className="takaful--layout-header-second-box-content">
                          <p>{sponsor?.overdue_amount}</p>
                          <span>مجموع المبالغ المتأخرة على حسابكم </span>
                        </div>
                        <Divider
                          type="vertical"
                          className={`takaful--layout-header-divider takaful--background-color-${
                            active === 1 ? "blue" : "white"
                          }`}
                        />
                        <div className="takaful--layout-header-second-box-content">
                          <p>{sponsor?.due_amount}</p>
                          <span>الاستحقاقات</span>
                        </div>
                      </div>
                    </Col>
                  ) : role === "beneficiary" ? (
                    <Col
                      xxl={6}
                      xl={6}
                      lg={8}
                      md={8}
                      sm={10}
                      xs={11}
                      className={`takaful--layout-header-second-box  takaful--text-color-${
                        active === 1 ? "blue" : "white"
                      }`}
                    >
                      <Divider
                        type="vertical"
                        className={`takaful--layout-header-divider takaful--background-color-${
                          active === 1 ? "blue" : "white"
                        }`}
                      />
                      <div className="takaful--layout-header-second-box-content">
                        <p>
                          {beneficiary?.write_date
                            ? new Date(beneficiary.write_date)
                                .toISOString()
                                .split("T")[0]
                                .replace(/-/g, "/")
                            : ""}
                        </p>
                        <span>تاريخ آخر تعديل</span>
                      </div>
                    </Col>
                  ) : (
                    <Col
                      xxl={6}
                      xl={6}
                      lg={8}
                      md={8}
                      sm={10}
                      xs={11}
                      className={`takaful--layout-header-second-box  takaful--text-color-${
                        active === 1 ? "blue" : "white"
                      }`}
                    >
                      <Divider
                        type="vertical"
                        className={`takaful--layout-header-divider takaful--background-color-${
                          active === 1 ? "blue" : "white"
                        }`}
                      />
                      <div className="takaful--layout-header-second-box-content"></div>
                    </Col>
                  )}

                  <Col xxl={0} xl={0} lg={0} md={0} sm={3} xs={2}>
                    <div className="takaful--layout-icons-container">
                      {/* REQUESTED BY CLIENT / TO BE RETURNED IN THE FUTURE
                      {isRoleSponsor(role) ? (
                        <div
                          className="takaful--navbar-profile-icon takaful--layout-profile-icon"
                          onClick={() => setIsWalletModalVisible(true)}
                        >
                          <img src={wallet} alt="setting" />
                        </div>
                      ) : (
                        <div className="takaful--navbar-profile-icon  takaful--layout-profile-icon">
                          <SettingOutlined />
                        </div>
                      )} */}
                      {hasRelatedAccounts && (
                        <Dropdown
                          menu={{
                            items: switchAccountItems,
                            onClick: handleSwitchAccount,
                          }}
                          placement="bottomRight"
                          trigger={["click"]}
                          overlayClassName="takaful--service-select-dropdown takaful--switch-account-dropdown"
                        >
                          <Tooltip
                            overlayClassName="takaful--share-tooltip"
                            placement="right"
                            title="إنتقل إلى حساب آخر"
                          >
                            <div className="takaful--navbar-profile-icon  takaful--layout-profile-icon">
                              <AiOutlineUserAdd />
                              <span className="notification-badge">
                                {sponsor?.accounts_number}
                              </span>
                            </div>
                          </Tooltip>
                        </Dropdown>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="takaful--layout-sidebar-container">
                {isExpanded ? (
                  <ArrowRightOutlined
                    className={`takaful--layout-sidebar-arrow svg-color-${
                      active === 1 ? "blue" : "white"
                    }
            `}
                    onClick={handleToggle}
                  />
                ) : (
                  <ArrowLeftOutlined
                    className={`takaful--layout-sidebar-arrow expaned svg-color-${
                      active === 1 ? "blue" : "white"
                    }
            `}
                    onClick={handleToggle}
                  />
                )}
                <Row justify={"space-between"} ref={currentRef}>
                  <Col
                    className="takaful--layout-content"
                    xxl={isExpanded ? 17 : 22}
                    xl={isExpanded ? 17 : 22}
                    lg={24}
                    md={24}
                    sm={24}
                    xs={24}
                  >
                    {content}
                  </Col>
                  <Col
                    className={`takaful--layout-sidebar`}
                    xxl={isExpanded ? 6 : 1}
                    xl={isExpanded ? 6 : 1}
                    lg={0}
                    md={0}
                    sm={0}
                    xs={0}
                  >
                    <MenuProfile
                      selectedItemMenu={selectedItemMenu}
                      setSelectedItemMenu={(key) => {
                        setSelectedItemMenu(key);
                      }}
                      setIsExpanded={setIsExpanded}
                      isExpanded={isExpanded}
                      role={role}
                      sponsor={sponsor}
                      menu={
                        role === "beneficiary"
                          ? beneficiaryMenu(club)?.slice(
                              1,
                              beneficiaryMenu(club)?.length
                            )
                          : isRoleEndower(role)
                            ? getMenu(role)?.slice(1, getMenu(role)?.length)
                            : ["sponsor", "sponsor_participant"].includes(role)
                              ? withParticipantMenu(
                                  withOldSystemPayments(
                                    sponsorMenu.filter(
                                      (item) =>
                                        item.key !== "s15" &&
                                        item.key !== "s19"
                                    ),
                                    sponsor
                                  ),
                                  role
                                ).slice(1)
                              : role === "school"
                                ? schoolMenu.slice(1, schoolMenu.length)
                                : withParticipantMenu(
                                    withOldSystemPayments(
                                      sponsorMenu.filter(
                                        (item) => item.key !== "s15"
                                      ),
                                      sponsor
                                    ),
                                    role
                                  ).slice(1)
                      }
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      )}
      <AddWalletAmount
        isWalletModalVisible={isWalletModalVisible}
        setIsWalletModalVisible={() => setIsWalletModalVisible(false)}
      />
    </>
  );
};
export default LayoutProfile;
